const reconstructTimeString = (timeAsNumber) => {
    timeAsNumber = timeAsNumber.toFixed(2).split('.');
    if (timeAsNumber[0].length === 1) {
        timeAsNumber[0] = 0 + timeAsNumber[0];
    }
    return timeAsNumber.join(":");
}

const sortAndCombineDayOfTimeblocks = (incomingBlocks) => {
    incomingBlocks.map(timeBlock => {
        timeBlock[0] = parseFloat(timeBlock[0].replace(":",'.'));
        timeBlock[1] = parseFloat(timeBlock[1].replace(":",'.'));
    });

    incomingBlocks.sort(function(a, b){return a[0]-b[0]});
    let combinedBlocks = [incomingBlocks[0]];
    for (let i = 1; i < incomingBlocks.length; i ++) {
        let index = combinedBlocks.length - 1;
        if (incomingBlocks[i][0] > combinedBlocks[index][1]) {
            combinedBlocks.push(incomingBlocks[i]);
        }
        else if (incomingBlocks[i][0] < combinedBlocks[index][1] && incomingBlocks[i][1] > combinedBlocks[index][1]) {
            combinedBlocks[index][1] = incomingBlocks[i][1];
        }
        else if (incomingBlocks[i][0] < combinedBlocks[index][1] && incomingBlocks[i][1] <= combinedBlocks[index][1]) {
            combinedBlocks[index] = incomingBlocks[i];
        }
        else if (incomingBlocks[i][0] === combinedBlocks[index][1]) {
            combinedBlocks[index][1] = incomingBlocks[i][1];
        }
    };

    combinedBlocks.map(timeBlock => {
        timeBlock[0] = reconstructTimeString(timeBlock[0]);
        timeBlock[1] = reconstructTimeString(timeBlock[1]);
    });
    return combinedBlocks;
};

export default sortAndCombineDayOfTimeblocks;


// WEBPACK FOOTER //
// ./src/js/containers/ProviderContainer/utils/sortAndCombineDayOfTimeblocks.js